import PropTypes from 'prop-types';
import React from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';

import TagPill from '@bibliocommons/deprecated-tag-pill';
import { Personal as PersonalIcon } from '@bibliocommons/deprecated-base-icons';
import { userIdentityShape, ugcTagShape } from '@bibliocommons/bc-prop-types';
import { TAG_TYPES } from '../../../../constants/TagsConstants';
import DisplayWrapper from '../DisplayWrapper';
import './TagDisplay.scss';

export default class TagDisplay extends React.PureComponent {
  renderTagPill() {
    const { tag, owner, url, handleClick, tagsTransactions, tagsActions } = this.props;
    const tagId = tag.get('id');
    const tagValue = tag.get('value');
    const tagType = tag.get('type');
    const metadataId = tag.get('metadataId');
    const renderIcon = () => tagType === TAG_TYPES.PERSONAL && <PersonalIcon />;
    const handleRemove =
      tagId && owner.get('loggedIn') ? () => tagsActions.removeTag(metadataId, tagId, tagType) : undefined;
    const isLoading = tagId ? tagsTransactions.getIn([metadataId, tagId, 'isRemoving'], false) : true;

    return (
      <TagPill
        value={tagValue}
        url={url}
        renderIcon={renderIcon}
        handleClick={handleClick}
        handleRemove={handleRemove}
        isLoading={isLoading}
      >
        {tagValue} ({tag.get('count')})
      </TagPill>
    );
  }

  render() {
    return <DisplayWrapper className="cp-ugc-tag-display">{this.renderTagPill()}</DisplayWrapper>;
  }
}

TagDisplay.propTypes = {
  handleClick: PropTypes.func,
  url: PropTypes.string,
  tag: PropTypes.oneOfType([
    ugcTagShape,
    ImmutablePropTypes.contains({
      metadataId: PropTypes.string.isRequired,
      type: PropTypes.oneOf(
        Immutable.Map(TAG_TYPES)
          .valueSeq()
          .toArray()
      ).isRequired,
      value: PropTypes.string.isRequired,
      count: PropTypes.number
    })
  ]).isRequired,
  owner: userIdentityShape.isRequired,
  tagsTransactions: ImmutablePropTypes.map.isRequired,
  tagsActions: PropTypes.objectOf(PropTypes.func).isRequired
};
